import { MantineProvider, v8CssVariablesResolver } from "@mantine/core"
import { ModalsProvider } from "@mantine/modals"
import { QueryClientProvider } from "@tanstack/react-query"
import { ErrorBoundary } from "./-components/error-context/error-boundary.tsx"
import { queryClient } from "./queryClient.ts"
import { MantineDatesProvider } from "./routes/-components/mantine-dates-provider.tsx"
import { theme } from "./theme.ts"
import { setNonce } from "get-nonce"

const nonce = window.__CSP_NONCE__
setNonce(nonce)

export function ApplicationProviders({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={v8CssVariablesResolver}
      getStyleNonce={() => nonce}
    >
      <ErrorBoundary
        autoReload={{ enabled: true, retries: 3, showReloadButton: true }}
      >
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <MantineDatesProvider>{children}</MantineDatesProvider>
          </ModalsProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </MantineProvider>
  )
}
